export type ThemeBackground = {
  textColor: string;
  color: string;
  bgStart?: string;
  bgEnd?: string;
};

type ThemeProperties = {
  actionColor: string;
  launcherButtonColor: string;
  /** Scale generated from the action color */
  actionColorScale: Record<ColorKey, string>;
  /** Text color that contrasts with the action color (usually white since action color should not be too light) */
  contrastTextColor: string;
  background: ThemeBackground;
};

export type Theme = {
  light: ThemeProperties;
  dark: ThemeProperties;
};

export const DEFAULT_THEME: Theme = {
  light: {
    actionColor: "#3A8DDE",
    actionColorScale: {
      900: "#033261",
      800: "#044C92",
      700: "#0565C3",
      600: "#237CD2",
      500: "#3A8DDE",
      400: "#55A1E3",
      300: "#9FCCF3",
      200: "#CFE5F9",
      100: "#E1EEFB",
      50: "#EBF4FC",
    },
    launcherButtonColor: "#3A8DDE",
    contrastTextColor: "#FFFFFF",
    background: {
      textColor: "#FFFFFF",
      color: "#3A8DDE",
      bgStart: undefined,
      bgEnd: undefined,
    },
  },
  dark: {
    actionColor: "#0565C3",
    actionColorScale: {
      900: "#011427",
      800: "#02284e",
      700: "#033d75",
      600: "#04519c",
      500: "#0565C3",
      400: "#237CD2",
      300: "#3A8DDE",
      200: "#55A1E3",
      100: "#9FCCF3",
      50: "#CFE5F9",
    },
    launcherButtonColor: "#0565C3",
    contrastTextColor: "#FFFFFF",
    background: {
      textColor: "#FFFFFF",
      color: "#3A8DDE",
      bgStart: undefined,
      bgEnd: undefined,
    },
  },
};

export const colorKeys = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900] as const;
export type ColorKey = (typeof colorKeys)[number];
export type ColorVar = `--color${ColorKey}`;
